import {useState, useEffect} from 'react';
import { useStateContext } from '../state-context/use_state_context.js';

const useModel = function(ModelClass, callback=(model) => (model.getData()), selectionCriteriaInput=null){

    const [state, ] = useStateContext();
    let selectionCriteria = null;
    if(typeof selectionCriteriaInput === 'function'){
        selectionCriteria = selectionCriteriaInput(state);
    }else{
        selectionCriteria = selectionCriteriaInput===null? state: selectionCriteriaInput;
    }
     
    const [data, setData] = useState({
        status: ModelClass.Status.INACTIVE, 
        data: []
    });

    const [lastModified, setLastModified] = useState(0);

    // sets up the model with callback
    useEffect(()=> {
        const cb = (model) => {
            // only update if there's something new (or older, it's possible that the model switched back to
            // an older instance)
            if(lastModified !== model.lastModified){
                setLastModified(model.lastModified);
                setData(callback(model));
            }
        };

        const {instanceId, listenerId} = ModelClass.addConsumer(ModelClass, selectionCriteria, cb);
        return () => {
            ModelClass.removeConsumer(ModelClass, instanceId, listenerId);
        }
    }, [ModelClass, selectionCriteria, callback, lastModified]);

    return data;

}

export {useModel};



